// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

import Box from '@mui/material/Box'
import Notice from '../ui/Notice'
import { SIGNING_WORDS } from '../../api/inappEsign'

/**
 * D-CRX-87 §4d — the two notes every CareRx send surface shows instead of a send the server would refuse.
 * One copy (E-01 rule of two): the document tracker, the Plan of Treatment queue and the Plan of Care dialog.
 * The server enforces both; these only explain.
 */

/** In app only: a document a provider or patient must sign cannot be sent (replaces the Send button). */
export function DocuSignOffNote() {
  return (
    <Box data-testid="docusign-off-note" sx={{ maxWidth: 320, mt: 0.5 }}>
      <Notice severity="info">{SIGNING_WORDS.inAppOnly}</Notice>
    </Box>
  )
}

/** DocuSign / Both, but DocuSign is not set up for this pharmacy: "Send with DocuSign" is disabled. */
export function DocuSignNotSetUpNote() {
  return (
    <Box data-testid="docusign-not-set-up" sx={{ mt: 1.5 }}>
      <Notice severity="warning">{SIGNING_WORDS.docusignNotSetUp}. Ask your administrator to connect DocuSign.</Notice>
    </Box>
  )
}
